<template>
  <div>
    <b-row>
      <b-col cols="12" :lg="8">
        <b-overlay :show="isLoading" :variant="`white`" :opacity="0.75" :blur="``" rounded="none">
          <b-card no-body>
            <div class="px-1 pt-1">
              <h3 class="d-flex justify-content-between w-100 border-bottom pb-75 mb-75">
                <span>
                  {{
                  $role===1
                  ? $t("lbl_test_requirement_info")
                  : $t("lbl_order_info")
                  }}
                </span>
                <span>#{{ orderDetail.order_code }}</span>
              </h3>
            </div>
            <div v-if="orderItemsProduct.length" class="px-1 mb-2">
              <h4 v-if="orderItemsService.length">
                <u>{{ $t("lbl_products") }}</u>
              </h4>
              <div class="bg-light p-1 rounded">
                <OrderInfomation
                  :orderDetail="orderDetail"
                  :orderItems="orderItemsProduct"
                  @refresh="handleGetViewDetail"
                  @setIsLoading="setIsLoading"
                  :isCancelOrder="isCancelOrder"
                />
              </div>
            </div>
            <div v-if="orderItemsService.length" class="px-1 mb-2">
              <h4 v-if="orderItemsProduct.length">
                <u>{{ $t("SERVICE") }}</u>
              </h4>
              <div class="bg-light rounded-top">
                <OrderInfomation
                  :orderDetail="orderDetail"
                  :orderItems="orderItemsService"
                  @refresh="handleGetViewDetail"
                  @setIsLoading="setIsLoading"
                  :isCancelOrder="isCancelOrder"
                />
              </div>
              <div class="p-1 rounded-bottom" style="background-color: #ebe9f1">
                <b-row>
                  <b-col cols="12" :lg="3">
                    <div class="process-timeline">
                      <div
                        v-for="(node, index) in activities"
                        :key="node.text"
                        class="process-timeline__item d-flex cursor-pointer"
                        v-b-tooltip.left
                        :title="checkProcessorReject && index === 2 ?
                          $t('lbl_order_is_rejected') : ''"
                        @click="
                          checkProcessorReject && index === 2
                            ? () => {}
                            : changeStep(node)
                        "
                      >
                        <div
                          class="node"
                          :class="{
                            active: node.isActive,
                            done: activeSteps[index],
                            cancel: checkProcessorReject && index === 2,
                          }"
                        >
                          <div v-if="index < activities.length - 1" class="node-line"></div>
                        </div>
                        <div class="node-text">{{ $t(node.text) }}</div>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12" :lg="9">
                    <div class="h-100">
                      <keep-alive>
                        <Transition name="fade" mode="out-in">
                          <component
                            v-if="orderDetail.hasOwnProperty('order_items')"
                            :is="activeComponent"
                            :orderDetail="orderDetail"
                            :apiPayload="payload"
                            :isCancelOrder="isCancelOrder"
                            :checkProcessorReject="checkProcessorReject"
                            class="order-detail-container"
                            @changeStatus="handleChangeStatus"
                            @onChangeStep="onChangeStep"
                            @submitForms="handleSubmitForms"
                            @addForms="handleAddFiles"
                            @refresh="handleGetViewDetail"
                          />
                        </Transition>
                      </keep-alive>
                    </div>
                  </b-col>
                </b-row>
              </div>
            </div>
          </b-card>
        </b-overlay>
      </b-col>
      <b-col cols="12" :lg="4">
        <b-card no-body>
          <div class="tabs-wrapper">
            <b-tabs fill content-class="mt-1">
              <b-tab active>
                <template #title>
                  <div class="w-100" v-b-tooltip.hover :title="$t('lbl_customer_order_info')">
                    <feather-icon icon="UserIcon" size="24" class="mr-0" />
                    <span class="d-none">
                      {{
                      $t("lbl_customer_order_info")
                      }}
                    </span>
                  </div>
                </template>
                <OrderReceiverInformation :orderContact="orderDetail.order_contact" />
              </b-tab>
              <b-tab>
                <template #title>
                  <div class="w-100" v-b-tooltip.hover :title="$t('Followers')">
                    <feather-icon icon="BellIcon" size="24" class="mr-0" />
                    <span class="d-none">{{ $t("Followers") }}</span>
                  </div>
                </template>
                <OrderFollowerInformation v-if="orderDetail.hasOwnProperty('followers')" :followers="orderDetail.followers" />
              </b-tab>
              <b-tab>
                <template #title>
                  <div class="w-100" v-b-tooltip.hover :title="$t('lbl_payment_info')">
                    <feather-icon icon="CreditCardIcon" size="24" class="mr-0" />
                    <span class="d-none">{{ $t("lbl_payment_info") }}</span>
                  </div>
                </template>
                <OrderPaymentInformation />
              </b-tab>
            </b-tabs>
          </div>
        </b-card>
        <b-card no-body>
          <h3 class="block p-1 mb-0">
            <span>
              {{
              $t($role===1? "lbl_total_price" : "lbl_total_order_price")
              }}:
            </span>
          </h3>
          <!-- Thông tin tổng giá trị đơn hàng -->
          <div class="px-1 pb-1">
            <div class="text-primary cs-bg p-1 h3 mb-0">{{ totalAmount }}</div>
          </div>
        </b-card>
        <CommentSection
          v-if="orderDetail.order_items && orderDetail.order_items[0]"
          :order="orderDetail"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AssignProcessor from "./Components/AssignProcessor.vue";
import { mapActions, mapState } from "vuex";
import OrderInfomation from "./Components/OrderInfomation.vue";
import SubmitForm from "./Components/SubmitForm.vue";
import OrderReceiverInformation from "./Components/OrderReceiverInformation.vue";
import OrderPaymentInformation from "./Components/OrderPaymentInformation.vue";
import OrderFollowerInformation from "./Components/OrderFollowerInformation.vue";
import Result from "./Components/Result.vue";
import CommentSection from "./Components/CommentSection.vue";
import useOrdersList from "../useOrdersList";
import {
  ORDERS_STATUS,
  PRODUCT_TYPES,
  RESULT_ORDER_ITEM_STATUS,
  ORDER_FORM_PROCESSOR_STATUS
} from "@/utils/constant";
import appUtils from "@/utils/appUtils";

export default {
  components: {
    CommentSection,
    OrderInfomation,
    SubmitForm,
    OrderReceiverInformation,
    OrderPaymentInformation,
    OrderFollowerInformation,
    Result,
    AssignProcessor
  },
  setup() {
    const { viewDetailOrders } = useOrdersList();
    return {
      viewDetailOrders
    };
  },
  data() {
    const initialTab = [
      {
        text: "lbl_test_register_profile",
        isActive: true,
        component: SubmitForm
      },
      {
        text: "lbl_assign_processor_node",
        isActive: false,
        component: AssignProcessor
      },
      {
        text: "lbl_return_the_results_to_customer",
        isActive: false,
        component: Result
      }
    ];
    return {
      appUtils,
      isLoading: true,
      orderDetail: {},
      initialTab,
      activities: [...initialTab],
      payload: [],
      currentActive: initialTab[0],
      orderItemsProduct: [],
      orderItemsService: []
    };
  },
  async created() {
    await this.handleGetViewDetail({ id: this.orderId });
    this.isLoading = false;
  },
  mounted() {
    if (Number(this.$route.query.step) === 1) {
      const stepInfo = this.initialTab[1];
      this.changeStep(stepInfo);
      this.$router.replace({ query: null });
    }
  },
  computed: {
    isCancelOrder() {
      return this.orderDetail?.status === ORDERS_STATUS.CANCELED;
    },
    orderId() {
      return this.$route.params.id;
    },
    activeComponent() {
      return this.activities.find(node => node.isActive)?.component;
    },
    ...mapState({
      payloadOrdersStore: state => state.orders.payloadOrders,
      is_test_provider: state => state.authenticate.is_test_provider,
      temporaryPayload: state => state.orders.temporaryPayload
    }),
    activeSteps() {
      const self = this;
      const activeStepsRaw = self.payload?.map((p, index) => {
        const isConsentAndRequisitionForm =
          !!p.url_concent_form && !!p.url_requisition_form;
        // const isOrderForm = !!p.url_order_form;
        const isAssignProcessor = !!p.processor_id;
        const isResult =
          self.orderDetail?.order_items[index]?.data?.document_link?.[0]
            ?.status === RESULT_ORDER_ITEM_STATUS.APPROVE;
        return {
          isConsentAndRequisitionForm,
          // isOrderForm,
          isAssignProcessor,
          isResult
        };
      });
      const isConsentAndRequisitionForm = [false].some(el =>
        activeStepsRaw
          ?.map(item => item?.isConsentAndRequisitionForm)
          .includes(el)
      );
      // const isOrderForm = [false].some((el) =>
      //   activeStepsRaw?.map((item) => item?.isOrderForm).includes(el)
      // );
      const isAssignProcessor = [false].some(el =>
        activeStepsRaw?.map(item => item?.isAssignProcessor).includes(el)
      );
      const isResult = [false].some(el =>
        activeStepsRaw?.map(item => item?.isResult).includes(el)
      );

      return [
        !isConsentAndRequisitionForm,
        // !isOrderForm,
        !isAssignProcessor,
        !isResult
      ];
    },
    totalAmount() {
      const total = this.orderDetail?.order_items?.reduce(
        (total, item) => total + Number(item?.data?.total_amount),
        0
      );
      if (!total) return "";
      return appUtils.numberFormat(total, "VNĐ");
    },
    checkProcessorReject() {
      const isReject = this.orderDetail?.order_items?.some(
        item =>
          item?.data?.order_processor?.status ===
          ORDER_FORM_PROCESSOR_STATUS.CANCEL
      );
      return isReject;
    }
  },
  watch: {
    orderDetail: {
      handler(data) {
        if (Object.keys(data)?.length) {
          this.makingOrderItems(data);
        }
      },
      deep: true
    },
    $route() {
      if (Number(this.$route.query.step) === 1) {
        const stepInfo = this.initialTab[1];
        this.changeStep(stepInfo);
        this.$router.replace({ query: null });
      }

      this.handleGetViewDetail({ id: this.orderId });
    }
  },
  methods: {
    ...mapActions("orders", ["fetchOrdersById"]),
    makingOrderItems(data) {
      this.orderItemsProduct = data?.order_items?.filter(
        item => item?.data?.type === PRODUCT_TYPES.PRODUCT
      );
      this.orderItemsService = data?.order_items?.filter(
        item => item?.data?.type === PRODUCT_TYPES.SERVICE
      );
    },
    changeStep(step) {
      this.$route.params.url = null;
      this.activities.find(node => node.isActive).isActive = false;
      step.isActive = true;
      this.currentActive = { ...step };
    },
    nextStep() {
      let indexOfCurrentStep = this.activities
        .map(step => step.isActive)
        .indexOf(true);
      let nextStep = this.activities[indexOfCurrentStep + 1];
      this.$store.commit("orders/updatePayloadOrders", this.payload);
      this.changeStep(nextStep);
    },
    handleChangeStatus(payload) {
      let item = this.orderDetail.order_items.find(
        item => item.data.id === payload.order_item_id
      );
      if (item) {
        item.data.status = payload.status.order_number;
        item.stepSelected = payload.status;
      }
    },
    handleSubmitForms({
      requisitionFormUrls,
      consentFormUrls,
      orderFormUrls,
      otherFormUrls
    }) {
      requisitionFormUrls.forEach((urls, index) => {
        this.payload[index].url_requisition_form = urls;
      });
      consentFormUrls.forEach((urls, index) => {
        this.payload[index].url_concent_form = urls;
      });
      orderFormUrls.forEach((urls, index) => {
        this.payload[index].url_order_form = urls;
      });
      otherFormUrls.forEach((urls, index) => {
        this.payload[index].url_other_form = urls;
      });
      this.nextStep();
    },
    handleAddFiles(formUrls, index, form_key) {
      this.payload[index][form_key] = [...formUrls];
    }, 
    isJSON(params) {
      if (params) {
        try {
          JSON.parse(params);
        } catch (error) {
          return false;
        }
        return typeof JSON.parse(params) === "object";
      } else return false;
    },
    async handleGetViewDetail(orderInfo) {
      const data = await this.viewDetailOrders(orderInfo);
      this.orderDetail = { ...data };

      const orderItemsService = this.orderDetail?.order_items?.filter(
        item => item?.data?.type === PRODUCT_TYPES.SERVICE
      );
      if (!orderItemsService) return;
      if (this.temporaryPayload && this.temporaryPayload.length) {
        this.payload = this.temporaryPayload;
        this.$store.commit("orders/updateTemporaryPayload", []);
      } else {
        const newPayload = orderItemsService?.map(el => {
          const payloadInfo = this.payloadOrdersStore?.find(
            payloadItem => payloadItem?.order_item_id === el?.data?.id
          );
          return {
            order_code: this.orderDetail.order_code,
            order_id: this.orderDetail.order_id,
            order_item_id: el.data.id,
            processor_id: el.data?.order_processor?.processor_id,
            url_concent_form:
              payloadInfo?.url_concent_form ||
              (this.isJSON(el.data?.order_processor?.concent_form_url)
                ? JSON.parse(el.data?.order_processor?.concent_form_url)
                : []),
            url_requisition_form:
              payloadInfo?.url_requisition_form ||
              el.data?.order_processor?.requisition_form
                ?.filter(item => item.type === 1)
                .map(el => {
                  return {
                    url: el.url,
                    canProcessorView: el.canProcessorView
                  };
                }) ||
              [],
            url_order_form:
              payloadInfo?.url_order_form ||
              (this.isJSON(el.data?.order_processor?.order_form_url)
                ? JSON.parse(el.data?.order_processor?.order_form_url)
                : []),
            url_other_form:
              payloadInfo?.url_other_form ||
              el.data?.order_processor?.requisition_form
                ?.filter(item => item.type === 2)
                .map(el => {
                  return {
                    url: el.url,
                    canProcessorView: el.canProcessorView
                  };
                }) ||
              [],
            id: el.data?.order_processor?.id,
            status: el.data?.order_processor?.status
          };
        });
        this.payload = newPayload;
      }
      this.isLoading = false;
    },
    setIsLoading(value) {
      this.isLoading = value;
    },
    onChangeStep(index) {
      let step = this.activities[index];
      this.changeStep(step);
    }
  }
};
</script>

<style lang="scss" scoped>
p {
  margin-bottom: 0px;
}
.title {
  text-align: center;
  font-weight: 700;
  font-size: 24px;
  margin-bottom: 25px;
  span {
    margin-left: 10px;
    font-weight: 400;
    font-size: 15px;
  }
}
.process-timeline {
  &__item {
    align-items: center;
    gap: 20px;
    height: 80px;
    .node {
      width: 28px;
      min-width: 28px;
      height: 28px;
      border-radius: 50%;
      background-color: #6a7580;
      position: relative;
      transition: all 0.3s ease;
      &-text {
        transition: all 0.3s ease;
      }
      &-line {
        position: absolute;
        width: 4px;
        height: 70px;
        background-color: #ced4da;
        top: 100%;
        left: 50%;
        transform: translateX(-50%);
      }
      &.active {
        background-color: #476dd6;
        & + .node-text {
          color: #476dd6;
        }
      }
      &.done {
        background-color: #28c76f !important;
        &::before {
          content: "✓";
          color: white;
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
      &.cancel {
        background-color: rgb(243, 22, 22) !important;
        &::before {
          content: "x";
          color: white;
          display: block;
          position: absolute;
          top: 48%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
    &:hover {
      // zoom: 1.1;
      .node {
        background-color: #476dd6;
        &-text {
          color: #476dd6;
        }
      }
    }
  }
}
.order-detail-wrapper {
  padding: 15px;
  background-color: white;
  border-radius: 10px;
  .order-detail-container {
    ::v-deep .title {
      font-size: 25px;
      font-weight: 400;
      text-align: center;
      margin: 1rem 0 2rem;
    }
    ::v-deep .row {
      margin: 20px 0px;
    }
    ::v-deep .image {
      padding-right: 0px;
      padding-left: 0px;
      width: 80px;
      height: 80px;
    }
  }
}
.tabs-wrapper {
  padding: 15px;
  background-color: white;
  border-radius: 10px;
}

.cs-bg {
  background-color: rgba(32, 65, 155, 0.12);
  border-radius: 10px;
  width: fit-content;
}
</style>
